import React from 'react';
import { useTheme } from '../../context/ThemeContext';

const Notification = ({ notifications, isMobile }) => {
    const { theme } = useTheme();

    return (
        <div style={{
            position: 'fixed',
            top: isMobile ? '12px' : '34px',
            right: isMobile ? '12px' : '34px',
            zIndex: 50,
            display: 'flex',
            flexDirection: 'column',
            gap: isMobile ? '12px' : '17px',
            maxWidth: isMobile ? '280px' : '350px'
        }}>
            {notifications.map(notification => (
                <div
                    key={notification.id}
                    style={{
                        padding: isMobile ? '12px 17px' : '17px 26px',
                        borderRadius: '5px',
                        boxShadow: '0 4px 7px rgba(40, 40, 40, 1)',
                        backgroundColor: notification.type === 'success' ? '#16a085' :
                            notification.type === 'error' ? theme.accent : '#16a085',
                        color: theme.text,
                        fontWeight: 'bold',
                        textTransform: 'uppercase',
                        animation: 'bubbleAppear 0.5s ease-in-out',
                        fontSize: isMobile ? '15px' : '19px',
                        wordBreak: 'break-word'
                    }}
                >
                    {notification.message}
                </div>
            ))}
        </div>
    );
};

export default Notification;
